export default __webpack_public_path__ + "static/media/pdf.430c3494.svg";